import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,0 C1489.35529,0 1920,430.644706 1920,960 C1920,1489.35529 1489.35529,1920 960,1920 C430.644706,1920 0,1489.35529 0,960 C0,787.312941 46.4188235,618.014118 134.174118,470.4 L134.174118,470.4 L231.190588,528.112941 C153.825882,658.221176 112.941176,807.529412 112.941176,960 C112.941176,1427.12471 492.875294,1807.05882 960,1807.05882 C1427.12471,1807.05882 1807.05882,1427.12471 1807.05882,960 C1807.05882,511.962353 1457.28,144 1016.47059,114.861176 L1016.47059,114.861176 L1016.47059,338.823529 L903.529412,338.823529 L903.529412,0 Z M322.334118,242.371765 L804.592941,724.743529 C849.204706,695.04 902.512941,677.647059 960,677.647059 C1115.63294,677.647059 1242.35294,804.367059 1242.35294,960 C1242.35294,1115.63294 1115.63294,1242.35294 960,1242.35294 C804.367059,1242.35294 677.647059,1115.63294 677.647059,960 C677.647059,902.512941 695.04,849.204706 724.743529,804.592941 L724.743529,804.592941 L242.371765,322.334118 L322.334118,242.371765 Z M960,790.588235 C866.597647,790.588235 790.588235,866.597647 790.588235,960 C790.588235,1053.40235 866.597647,1129.41176 960,1129.41176 C1053.40235,1129.41176 1129.41176,1053.40235 1129.41176,960 C1129.41176,866.597647 1053.40235,790.588235 960,790.588235 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTimerLine = /*#__PURE__*/function (_Component) {
  _inherits(IconTimerLine, _Component);

  var _super = _createSuper(IconTimerLine);

  function IconTimerLine() {
    _classCallCheck(this, IconTimerLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconTimerLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTimer",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTimerLine.displayName = "IconTimerLine";
  return IconTimerLine;
}(Component);

IconTimerLine.glyphName = 'timer';
IconTimerLine.variant = 'Line';
IconTimerLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTimerLine;
export { IconTimerLine };